import apple_mac from "./images/apple-mac.svg";
import balloon from "./images/balloon.svg";
import chat from "./images/chat.svg";
import google_play_store from "./images/google-play-store.svg";
import house_with_hand from "./images/house-with-hand.svg";
import mala from "./images/mala.svg";
import message from "./images/message.svg";
import person from "./images/person.svg";
import question_mark_circle from "./images/question-mark-circle.svg";
import shake_hands from "./images/shake-hands.svg";
import star from "./images/star.svg";
import whatsapp from "./images/whatsapp.svg";

export const iconMap: Record<string, string> = {
  apple_mac,
  balloon,
  chat,
  google_play_store,
  house_with_hand,
  mala,
  message,
  person,
  question_mark_circle,
  shake_hands,
  star,
  whatsapp,
};
